import { FC, memo, useMemo } from 'react';
import { AxiosError } from 'axios';
import { EditIconButton } from 'components/elements';
import { IOption } from 'components/elements/CustomSelect';
import toastService from 'components/elements/Toastify';
import { useAppDispatch } from 'store/hooks';
import { updateStreets } from 'store/streets';
import { IErrorResponse, IStreetFormValues, IStreetsDetails } from 'types';
import { getCityOptionTitle, getErrorMessage } from 'utils/helpers';
import { useModal } from 'utils/hooks';
import { ManageStreetModal } from '../ManageStreetModal';

interface UpdateStreetAnchorProps {
	cityOptions: IOption[];
	cityOptionsLoading: boolean;
	hasMoreCityOptions: boolean;
	onCityLoadMore: () => void;
	onCitySearch: (search: string) => void;
	streetRow: IStreetsDetails;
}

export const UpdateStreetAnchor: FC<UpdateStreetAnchorProps> = memo(({
	cityOptions,
	cityOptionsLoading,
	hasMoreCityOptions,
	onCityLoadMore,
	onCitySearch,
	streetRow,
}) => {
	const [isOpen, handleOpen, handleClose] = useModal();
	const dispatch = useAppDispatch();

	const initialValues = useMemo(
		() => ({
			name: streetRow.name,
			streetTypeId: streetRow.streetTypeId,
			cityId: streetRow.cityId,
		}),
		[streetRow]
	);

	const handleUpdateModal = async (values: IStreetFormValues) => {
		try {
			await dispatch(
				updateStreets({
					...streetRow,
					name: values.name.trim(),
					streetTypeId: values.streetTypeId,
					cityId: Number(values.cityId),
					deviceFP: '6037e65eefbdasdfadsfasdf3',
				})
			).unwrap();
			handleClose();
		} catch (error) {
			toastService.error(getErrorMessage(error as AxiosError<IErrorResponse>));
		}
	};

	return (
		<>
			<EditIconButton
				onClick={() => {
					void onCitySearch(streetRow.city?.name || '');
					handleOpen();
				}}
			/>
			<ManageStreetModal
				title="Редагувати вулицю"
				isOpen={isOpen}
				onClose={handleClose}
				initialValues={initialValues}
				initialCityTitle={getCityOptionTitle(streetRow.cityId, streetRow.city?.name || '')}
				onSubmit={handleUpdateModal}
				cityOptions={cityOptions}
				cityOptionsLoading={cityOptionsLoading}
				onCitySearch={onCitySearch}
				onCityLoadMore={onCityLoadMore}
				hasMoreCityOptions={hasMoreCityOptions}
				buttonText="Змінити"
			/>
		</>
	);
});
